import PropTypes from 'prop-types';
import {getWindow} from 'ssr-window';
import EnvironmentUtils from '@spothero/utils/environment';

const window = getWindow();

export const SEARCH_TYPE = PropTypes.oneOf([
    'address',
    'destination',
    'event',
    'venue',
    'city',
]);

export const GOOGLE_MAPS_LAT_LNG = EnvironmentUtils.isBrowser()
    ? PropTypes.instanceOf(window.google.maps.LatLng)
    : null;
